import script from "./LoginChoice.vue?vue&type=script&setup=true&lang=js"
export * from "./LoginChoice.vue?vue&type=script&setup=true&lang=js"

import "./LoginChoice.vue?vue&type=style&index=0&id=478a459c&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-478a459c"]])

export default __exports__